export const EVERY_30_DAYS = "EVERY_30_DAYS";
export const ANNUAL = "ANNUAL";